/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { SummaryRequestBuilderRequestsMetadata, type SummaryRequestBuilder } from './summary/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/carts
 */
export interface CartsRequestBuilder extends BaseRequestBuilder<CartsRequestBuilder> {
    /**
     * The summary property
     */
    get summary(): SummaryRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const CartsRequestBuilderUriTemplate = "{+baseurl}/api/analytics/carts";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CartsRequestBuilderNavigationMetadata: Record<Exclude<keyof CartsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    summary: {
        requestsMetadata: SummaryRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
